<div class="container" *ngIf="!loading">
    <h4 class="page-title"></h4>
    <form [formGroup]="form">
        <div class="row">
            <div class="px-3 pt-1 pb-3">
                There {{(pledgeCount$ | async) === 1 ? 'is' : 'are'}} <strong>{{pledgeCount$ | async}}</strong> record{{(pledgeCount$ | async) === 1 ? '' : 's'}} available to add to a batch in the payment file.
                <br>
                Creating a new Batch will move those pledges from the Confirmed to Pending status.
            </div>
            <div class="form-group row pt-4">
                <div class="col-md-6">
                    <label>Start Date:</label>
                    <input type="text" class="w-100 form-control" bsDatepicker [formControl]="startDate">
                </div>
                <div class="col-md-6">
                    <label>End Date:</label>
                    <input type="text" class="w-100 form-control" bsDatepicker [formControl]="endDate">
                </div>
            </div>

            <div class="form-group row">
                    <label class="col-md-2">Companies:</label>
                    <div class="col-md-10">
                        <ng-select
                                [items]="companies"
                                bindLabel="name"
                                bindValue="id"
                                groupBy="category"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                [selectableGroup]="false"
                                [searchFn]="customSearchFn"
                                formControlName="companies"
                                placeholder="Filter by companies..."
                        >
                            <ng-template ng-optgroup-tmp let-item="item">
                                {{ item.category || 'Unnamed group' }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                <ng-container *ngIf="indexOf(item) < 5">
                                  <span class="select-item">
                                    {{ item.name }}
                                      <span class="ng-value-icon" (click)="clear(item)">×</span>
                                  </span>
                                </ng-container>
                                <ng-container *ngIf="indexOf(item) === 5">
                                    <span class="additional-text select-item">{{ getAdditionalItemsText() }}</span>
                                </ng-container>
                            </ng-template>
                        </ng-select>
                    </div>
            </div>

            <div class="form-group row">
                    <label class="col-md-2">Select Fund(s)</label>
                    <div class="col-md-10">
                        <pledgeTypeCheckbox [filterByRole]="true" [control]="pledgeTypes" [requireOne]="true"
                                            [showSelectAll]="true"
                                            [preselectAll]="true"></pledgeTypeCheckbox>
                    </div>
            </div>

                <div class="pt-1 action-buttons">
                    <button [disabled]="loading || (((pledgeCount$ | async) < 1))"
                            class="btn btn-primary" (click)="createBatch()">Create Batch
                    </button>
                </div>
                <div *ngIf="!this.loading && ((pledgeCount$ | async) < 1)"
                     class="alert-warning p-2 mt-2">There are no pledges available for the filters applied.
                </div>
                <ng-content></ng-content>
        </div>
    </form>
</div>
<div *ngIf="loading" class="loading-text">
    <h2>Loading...</h2>
</div>
